// extracted by mini-css-extract-plugin
export default {"linkToUrbanease":"urbaneaseLink_linkToUrbanease__-8EQF"};